import { render, staticRenderFns } from "./ArrangeSections.vue?vue&type=template&id=0c3e31ea&scoped=true&"
import script from "./ArrangeSections.vue?vue&type=script&lang=js&"
export * from "./ArrangeSections.vue?vue&type=script&lang=js&"
import style0 from "./ArrangeSections.vue?vue&type=style&index=0&id=0c3e31ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3e31ea",
  null
  
)

export default component.exports